module.exports = __webpack_public_path__ + "img/saddle-cloths-4.38daf7ee.svg";